/**
 * 将 nasStorageSoftwarePpt.json 的 lines 解析为幻灯片结构，用于网页按 PPT 版式展示。
 */

function isPageMarker(s) {
  if (!s || typeof s !== 'string') return false;
  const t = s.trim();
  return /^(0?\d|1\d|2\d|30)$/.test(t) && t.length <= 2;
}

/** 判断是否为短标题行（PPT 小标题），与正文区分 */
function isLikelySubheading(s) {
  if (!s || typeof s !== 'string') return false;
  const t = s.trim();
  if (!t) return false;
  if (/^\d{2}$/.test(t)) return false;
  if (t.length < 4) return false;
  if (t.includes('。')) return false;
  if (t.length > 14) return false;
  /* 带逗号、顿号的长句多为正文，即使总长度刚好 ≤10 也不作小标题 */
  if ((t.includes('，') || t.includes('、')) && t.length >= 8) return false;
  return true;
}

function parseNumbered(rest) {
  if (!rest.length || !/^\d{2}$/.test((rest[0] || '').trim())) return null;
  const blocks = [];
  let i = 0;
  while (i < rest.length) {
    const num = (rest[i] || '').trim();
    if (!/^\d{2}$/.test(num)) break;
    const headline = rest[i + 1] ?? '';
    const body = rest[i + 2] ?? '';
    if (!headline && !body) break;
    blocks.push({ num, headline, body });
    i += 3;
  }
  if (blocks.length === 0 || i !== rest.length) return null;
  return { consumed: i, blocks };
}

/**
 * 分组：可选 banner + 若干 { subtitle, bullets[] }
 */
function parseGrouped(rest) {
  let i = 0;
  let banner = null;
  /* 横幅 + 下挂要点：前两行均为小标题，第三行起为正文（如「全栈国产化」+「芯片架构」+长句） */
  if (
    rest.length >= 3 &&
    isLikelySubheading(rest[0]) &&
    isLikelySubheading(rest[1]) &&
    !isLikelySubheading(rest[2])
  ) {
    banner = rest[0].trim();
    i = 1;
  }

  const sections = [];
  while (i < rest.length) {
    if (!isLikelySubheading(rest[i])) {
      i += 1;
      continue;
    }
    const subtitle = rest[i].trim();
    i += 1;
    const bullets = [];
    while (i < rest.length && !isLikelySubheading(rest[i])) {
      bullets.push(rest[i].trim());
      i += 1;
    }
    sections.push({ subtitle, bullets });
  }

  if (sections.length === 0) return null;
  return { banner, sections };
}

/** 两列要点：成对 (subtitle, body) */
function parsePairs(rest) {
  const pairs = [];
  for (let i = 0; i < rest.length; i += 2) {
    pairs.push({
      subtitle: (rest[i] || '').trim(),
      text: (rest[i + 1] || '').trim(),
    });
  }
  return pairs.filter((p) => p.subtitle || p.text);
}

/**
 * @param {string[]} lines
 * @returns {{ type: string, [key: string]: any }}
 */
export function parseSlideLines(lines) {
  const title = (lines[0] || '').trim();
  const rest = (lines.slice(1) || []).map((x) => String(x).trim());

  if (rest.length === 0) {
    return { type: 'cover', title };
  }

  if (rest.length === 1 && isPageMarker(rest[0])) {
    return { type: 'section', title, page: rest[0].trim() };
  }

  const numbered = parseNumbered(rest);
  if (numbered) {
    return { type: 'numbered', title, blocks: numbered.blocks };
  }

  const grouped = parseGrouped(rest);
  if (grouped && grouped.sections.length > 0) {
    return {
      type: 'grouped',
      title,
      banner: grouped.banner,
      sections: grouped.sections,
    };
  }

  const pairs = parsePairs(rest);
  if (pairs.length > 0) {
    return { type: 'pairs', title, pairs };
  }

  return { type: 'fallback', title, lines: rest };
}

/**
 * @param {Array<{ lines: string[] }>} rawSlides
 */
export function parseAllSlides(rawSlides) {
  if (!rawSlides?.length) return [];
  return rawSlides.map((s) => parseSlideLines(s.lines || []));
}